import { useRequestEvent } from '#imports'

import { getMarketFromDomain } from '../helpers/getMarketFromDomain'
import { getMarketplace } from '../helpers/getMarketplace'
import { getRequestCountryCode } from '../helpers/getRequestCountryCode'

/**
 * Retrieve the current marketplace.
 *
 * The return type depends on Features (@backmarket/nuxt-module-marketplace/features).
 * This interface may be augmented by consumer packages.
 *
 * const marketplace = useMarketplace()
 *
 * @warning
 * For all usage as part of Nitro context, use `getMarketplace` instead.
 */
export function useMarketplace() {
  const event = useRequestEvent()

  if (event) {
    const countryCode = getRequestCountryCode(event)

    return getMarketplace(countryCode)
  }

  const domain = window.location.origin
  const market = getMarketFromDomain(domain)

  return getMarketplace(market.countryCode)
}
